import { render } from "./LayAnnotationList.vue?vue&type=template&id=696a6f1a&scoped=true"
import script from "./LayAnnotationList.vue?vue&type=script&lang=js"
export * from "./LayAnnotationList.vue?vue&type=script&lang=js"

import "./LayAnnotationList.vue?vue&type=style&index=0&id=696a6f1a&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696a6f1a"]])

export default __exports__